<template>
  <v-card flat class="mt-2">
    <v-card-text v-if="!questions?.length" class="pa-5 text-center">
      <LoadingSpinner />
    </v-card-text>
    <v-card-text v-if="questions && !questions.length" class="pa-5">
      There are no Questions for this Order Form
    </v-card-text>

    <v-card-title class="title-font pb-0">
      ORDER FORM
      <v-spacer />
      <div v-if="showErrors && !reviewed" class="error--text text-body-2">
        <v-icon color="error" class="mr-2">mdi-close-circle</v-icon>
        <span> Please mark as reviewed </span>
      </div>
      <v-btn
        fab
        elevation="0"
        x-small
        @click="collapsed = !collapsed"
        class="ml-2"
      >
        <v-icon>
          {{ collapsed ? "mdi-chevron-down" : "mdi-chevron-up" }}
        </v-icon>
      </v-btn>
    </v-card-title>
    <v-checkbox
      label="I have reviewed the client order form"
      v-model="reviewed"
      class="ml-4 mt-0 mb-2"
      hide-details
      :disabled="reviewed"
    />
    <v-expand-transition>
      <div v-if="!collapsed">
        <v-card
          flat
          outlined
          v-if="questions?.length"
          class="mx-4 overflow-y-auto rounded-10 pb-4"
          max-height="450"
        >
          <v-card
            class="rounded-10 px-4"
            v-for="(question, index) in questions"
            :key="index"
            flat
          >
            <div
              v-if="
                question.widget !== 'tooth_picker' &&
                question.widget !== 'date_picker'
              "
            >
              <v-card-title :class="['mx-0', 'px-0', { 'pt-0': index === 0 }]">
                {{ question.name }}
              </v-card-title>

              <v-card-subtitle>
                {{ question.description }}
              </v-card-subtitle>
            </div>

            <v-text-field
              v-if="question.widget === 'text_field'"
              v-model="orderForm[toSnakeCase(question.name)]"
              :label="`Answer ${question.mandatory ? '(Required)' : ''}`"
              outlined
              dense
              hide-details="auto"
            />
            <v-textarea
              v-if="question.widget === 'text_area'"
              v-model="orderForm[toSnakeCase(question.name)]"
              label="Answer"
              rows="1"
              hide-details="auto"
              auto-grow
              outlined
              dense
            />
            <v-select
              v-if="question.widget === 'drop_down_picker'"
              v-model="orderForm[toSnakeCase(question.name)]"
              label="Answer"
              :items="availableResponses(question)"
              outlined
              dense
              hide-details="auto"
              :menu-props="{ rounded: '10' }"
            />
          </v-card>
        </v-card>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex"
import { toSnakeCase } from "@/utils"

export default {
  name: "ClientOrderForm",

  props: ["value"],

  inject: ["form"],

  data() {
    return {
      collapsed: false,
      reviewed: false,
      showErrors: false,
      valid: true
    }
  },

  computed: {
    ...mapGetters(["selectedOrderSession", "orderFormQuestions"]),

    orderForm: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      }
    },

    questions() {
      if (this.orderFormQuestions === null) return []
      return this.orderFormQuestions
    }
  },

  watch: {
    reviewed(val) {
      if (val && this.showErrors) this.showErrors = false
    }
  },

  methods: {
    toSnakeCase,

    availableResponses(question) {
      return question.metadata?.responses?.map((response) => {
        return {
          text: response.name,
          value: response.name
        }
      })
    },

    validate() {
      if (!this.reviewed) this.showErrors = true
      this.valid = !!this.reviewed
      return !!this.reviewed
    }
  },

  created() {
    this.form.register(this)
  }
}
</script>
